import localStorageHelper from '@/helpers/localStorageHelper'
import investorStatuses, {registrationStatuses} from '@/config/investorStatuses'

export default {
  name: 'Loading',
  data()
  {
    return {
      loadedData: {
        investor: false,
        filters: false,
        classificators: false
      },
      loaded: false
    }
  },
  created()
  {
    // if (localStorage.getItem('accessToken'))
    // {
      // Load data for investor
    /*
       this.$store.dispatch('investors/fetchUserInvestor')
      this.$store.dispatch('filters/fetchFilters')
      this.$store.dispatch('classificators/fetchClassificators')
      */
    // }
    // else
    // {
    //   this.$router.push('/')
    // }
  },
  computed: {
    isInvestorLoaded: function ()
    {
      return !!this.$store.state.investors.investor
    },
    isFiltersLoaded: function ()
    {
      return !!this.$store.state.filters.filters
    },
    isClassificatorsLoaded: function ()
    {
      return !!this.$store.state.classificators.classificators
    }
  },
  watch: {
    loadedData:
      {
        handler(val)
        {
          // eslint-disable-next-line no-unused-vars
          for (const [key, value] of Object.entries(this.loadedData))
          {
            if (value === false)
            {
              return false
            }
          }
          // console.log('ALL IS LOADED!')
          if (this.isClosedAccount()) {
            localStorageHelper.set('showClosedAccountMsg', 1)
            this.$auth.logout({
              returnTo: window.location.origin + '/logout'
            })
          }
          this.loaded = true
          if (localStorageHelper.get('loggedIn') && !this.isActivated())
          {
            localStorageHelper.remove('loggedIn') // one time redirect after login
            this.$router.push('/register-complete')
          }

          if (this.isIdentityCompleted() && (
              this.$route.path === '/register' ||
              this.$route.path === '/register-complete'
            ))
          {
            this.$router.push('/account')
          }
        },
        deep: true
      },
    isInvestorLoaded: function ()
    {
      if (this.isInvestorLoaded)
      {
        this.loadedData.investor = true
        // console.log('Investor is loaded! :', this.$store.state.investors.investor)
      }
    },
    isFiltersLoaded: function ()
    {
      if (this.isFiltersLoaded)
      {
        this.loadedData.filters = true
        // console.log('Filters is loaded! :', this.$store.state.filters.filters)
      }
    },
    isClassificatorsLoaded: function ()
    {
      if (this.isClassificatorsLoaded)
      {
        this.loadedData.classificators = true
        this.$auth.classificators = this.$store.state.classificators.classificators
        // console.log('Classificators is loaded! :', this.$store.state.classificators.classificators)
      }
    }
  },
  mounted()
  {
    const currentRoutePath = this.$router.currentRoute.path
    if (currentRoutePath !== '/register' &&
      currentRoutePath !== '/settings' &&
      currentRoutePath !== '/invest' &&
      currentRoutePath.indexOf('/strategy/') !== 0 &&
      currentRoutePath !== '/investments' &&
      currentRoutePath !== '/confirm-investment'
    )
    {
      this.loadedData.classificators = true
    }
    if (currentRoutePath !== '/invest' && currentRoutePath.indexOf('/strategy/') !== 0 && currentRoutePath !== '/investments')
    {
      this.loadedData.filters = true
    }
    if (this.$store.state.investors.investor)
    {
      this.loadedData.investor = true
    }
    if (this.$store.state.filters.filters)
    {
      this.loadedData.filters = true
    }
    if (this.$store.state.classificators.classificators)
    {
      this.loadedData.classificators = true
      this.$auth.classificators = this.$store.state.classificators.classificators
    }
    // Try to load not already loaded data
    setTimeout(() =>
    {
      if (!this.loaded)
      {
        // eslint-disable-next-line no-unused-vars
        for (const [key, value] of Object.entries(this.loadedData))
        {
          if (value === false)
          {
            switch (key)
            {
              case 'filters':
                this.$store.dispatch('filters/fetchFilters')
              break
              case 'classificators':
                this.$store.dispatch('classificators/fetchClassificators')
              break
              case 'investor':
                this.$store.dispatch('investors/fetchUserInvestor')
                break
            }
          }
        }
      } else {
        if (this.isClosedAccount())
        {
          localStorageHelper.set('showClosedAccountMsg', 1)
          this.$auth.logout({
            returnTo: window.location.origin + '/logout'
          })
        }
      }
    }, 2500, this)
    setTimeout(() =>
    {
      if (!this.loaded)
      {
        console.log('Something went wrong. Redirect on main page...', currentRoutePath, this.loaded)
        this.$root.$emit('showunavailable', true)
        // this.$router.push('/')
      } else {
        if (this.isClosedAccount())
        {
          localStorageHelper.set('showClosedAccountMsg', 1)
          this.$auth.logout({
            returnTo: window.location.origin + '/logout'
          })
        }
      }
    }, 10000, this)
  },
  methods: {
    isActivated()
    {
      const investor = this.$store.state.investors.investor
      if (!investor)
      {
        return false
      }

      return !registrationStatuses.includes(investor.investor_account_status)
    },
    isFrozen()
    {
      const investor = this.$store.state.investors.investor
      if (!investor)
      {
        return false
      }
      return (investor.investor_freeze === 1)
    },
    isCompany()
    {
      const investor = this.$store.state.investors.investor
      if (!investor)
      {
        return false
      }
      return (investor.investor_is_company === 1 || investor.investor_is_company === true)
    },
    isKYC()
    {
      const investor = this.$store.state.investors.investor
      if (!investor)
      {
        return false
      }
      return (investor.investor_kyc === 1)
    },
    isIdentityCompleted()
    {
      // console.log('Is activated:', this.isActivated())
      // console.log('Is !isFrozen:', !this.isFrozen())
      // console.log('Is !isDocsExpired:', !this.isDocsExpired())
      // console.log('this.isActivated() && !this.isFrozen() && !this.isDocsExpired():', this.isActivated() && !this.isFrozen() && !this.isDocsExpired())
      return (this.isActivated() && !this.isFrozen() && !this.isDocsExpired())
    },
    isClosedAccount()
    {
      const investor = this.$store.state.investors.investor
      if (investor)
      {
        return (investor.investor_account_status === investorStatuses.CLOSED)
      }
    },
    isDocsExpired()
    {
      const investor = this.$store.state.investors.investor
      if (!investor)
      {
        return false
      }
      return (investor.investor_account_status === investorStatuses.APPROVED && investor.days_until_doc_expired && investor.days_until_doc_expired <= 30)
    }
  }
}
